import { useExternalPlatform } from '@/shared/externalPlatform';
import {
  googleClassroomContextManager,
  UserType,
} from '@/shared/googleClassroom';
import { useIsLtiInstructor } from '@/shared/lti';

export type AiBuilderChatUnavailableReason = 'external-platform-student';

export type AiBuilderChatAvailability = {
  canUseAiBuilderChat: boolean;
  unavailableReason: AiBuilderChatUnavailableReason | null;
};

export const useAiBuilderChatAvailability = (): AiBuilderChatAvailability => {
  const { mode } = useExternalPlatform();
  const isLtiInstructor = useIsLtiInstructor();

  if (mode === 'lti') {
    return {
      canUseAiBuilderChat: isLtiInstructor,
      unavailableReason: isLtiInstructor ? null : 'external-platform-student',
    };
  }

  if (mode === 'googleClassroom') {
    const context = googleClassroomContextManager.getLandingPageContext();
    const isTeacher = context?.userType === UserType.Teacher;

    return {
      canUseAiBuilderChat: isTeacher,
      unavailableReason: isTeacher ? null : 'external-platform-student',
    };
  }

  return {
    canUseAiBuilderChat: true,
    unavailableReason: null,
  };
};
